import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.558c1592.js","_app/immutable/chunks/scheduler.85e01571.js","_app/immutable/chunks/index.a7ffdff2.js","_app/immutable/chunks/Loading.27dbcd46.js","_app/immutable/chunks/index.282274ee.js"];
export const stylesheets = ["_app/immutable/assets/2.2a4918a6.css","_app/immutable/assets/Loading.218e0f39.css"];
export const fonts = [];
